// extracted by mini-css-extract-plugin
export default {"productCarousel":"SZ-z"};